export const roundDown = (x, n) => {
   if (n >= 0) return Math.floor(x / 10 ** n) * 10 ** n;
   else if (n < 0) return Math.floor(x * 10 ** -n) / 10 ** -n;
};

export const getPercent = (x) => {
   return roundDown(x * 100, 1);
};
